import React from 'react';
import {useTheme} from '../../theme';
import {Layout} from '../layout';
import {Spacer} from '../spacer';
import {RulerProps} from './types';

export const Ruler: React.FC<RulerProps> = ({
  color = 'border_mono_10',
  vertical,
  width = '1',
  padding,
}) => {
  const theme = useTheme();
  return (
    <>
      {padding && <Spacer width={padding} height={padding} />}
      {vertical ? (
        <Layout
          backgroundColor={color}
          width={theme.borders[width]}
          alignSelf="stretch"
        />
      ) : (
        <Layout
          backgroundColor={color}
          height={theme.borders[width]}
          alignSelf="stretch"
          vertical
        />
      )}
      {padding && <Spacer width={padding} height={padding} />}
    </>
  );
};
